import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex justify-end h-8 ml-2 space-x-2"
};
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import VoteButton from '@/components/groups/VoteButton.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'VotingSection',
    props: {
        group: null
    },
    setup(__props) {
        const retroStore = useRetroStore();
        const { isParticipant, votingMechanic, isDoneVoting } = storeToRefs(retroStore);
        return (_ctx, _cache) => {
            return (_unref(isParticipant) && !_unref(isDoneVoting))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(VoteButton, {
                        group: __props.group,
                        weight: 1
                    }, null, 8, ["group"]),
                    (_unref(votingMechanic) === 'one_and_two')
                        ? (_openBlock(), _createBlock(VoteButton, {
                            key: 0,
                            group: __props.group,
                            weight: 2
                        }, null, 8, ["group"]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
